import React from 'react';
import PropTypes from 'prop-types';
import { slide as Menu } from 'react-burger-menu';
import { Nav } from 'react-bootstrap';
import { getAvatarByProfile } from '../../utils/profileUtils';
import AccountLogo from '../../static/images/person-circle.svg';
import './styles.scss';

function AccountMenu ({
     profiles=[], 
     avatars=[], 
     handleOnSelectProfile, 
     openProfileMenu=false, 
     setOpenProfileMenu, 
     isRight=false,
     profileOptionsProps=[],
     profileOperationProps=[],
     currentProfileSelected,
     isAdminProfileSelected,
     adultMaxRatingDefault = 3
    }) {

  const { id: currentProfileId } = currentProfileSelected || {};

  const handleStateChange = (state) => {
    setOpenProfileMenu(state.isOpen)
  }

  return (
      <div className='accountMenuContainer'>
        <Menu 
              right={isRight} 
              isOpen = {openProfileMenu} 
              onStateChange={(state) => handleStateChange(state)}
              bodyClassName={"disableScroll"}
              customBurgerIcon={ false } 
            >
               <Nav>
                {
                  profiles?.map((profile,index)=> 
                  {
                  const avatarImg = getAvatarByProfile(avatars, profiles, profile.id)?.src;
                  return (
                          <div key={`profileLinkContainer-${index}-${profile.id}`}>
                            <Nav.Link className={`profileLinkContainer ${currentProfileId === profile.id? 'active': ''} `} key={profile.id} onClick={()=>handleOnSelectProfile(profile.id)}> 
                                <img alt='avatar'src={avatarImg ? avatarImg : AccountLogo}/>
                                {profile.name}
                                {profile?.hasPIN && profile?.max_rating < adultMaxRatingDefault  &&  <i class="bi bi-lock-fill"></i>}
                            </Nav.Link>
                          </div>
                        )
                   }
                  )

                }  

                {        
                  profileOperationProps?.map((option)=>
                  <Nav.Link className='optionLinkContainer' key={option.name} onClick={option?.handleOnClick}> 
                      <span className='textOperation'>{option.name}</span>
                  </Nav.Link>
                  )
                }
                <hr className='divisorContainer'></hr>
                {
                  profileOptionsProps?.map((option,index)=> 
                  <Nav.Link className='optionLinkContainer' key={'optionLinkContainer-'+index+'-'+option.name} onClick={option?.handleOnClick}> 
                      <span className='textOption'>{option.name}</span>
                  </Nav.Link>
                  )
                }
                </Nav>
        </Menu>
        </div>

    )
}

AccountMenu.propTypes = {
  profiles: PropTypes.array.isRequired,
  avatars: PropTypes.array.isRequired,
  handleOnSelectProfile: PropTypes.func.isRequired,
  openProfileMenu: PropTypes.bool,
  setOpenProfileMenu: PropTypes.func.isRequired,
  isRight: PropTypes.bool,
  profileOptionsProps: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    handleOnClick: PropTypes.func
  })),
  currentProfileSelected: PropTypes.object,
  isAdminProfileSelected: PropTypes.bool,
  adultMaxRatingDefault: PropTypes.string

};

export default React.memo(AccountMenu);
